import { createSelectFieldsDto, type SelectFieldsInterface } from '@zaoblako/shared/common/dtos/select-fields.dto';
import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

/** Registry column keys for internal users BASIS (`select` filter / column picker). */
export type UserRegistryColumnKey =
  | 'profile.name'
  | 'profile.email'
  | 'profile.phone'
  | 'job'
  | 'roles'
  | 'contragent'
  | 'workSchedule'
  | 'activitiesCount'
  | 'accessCard';

export const USER_REGISTRY_COLUMN_KEYS: UserRegistryColumnKey[] = [
  'profile.name',
  'profile.email',
  'job',
  'profile.phone',
  'roles',
  'contragent',
  'workSchedule',
  'activitiesCount',
  'accessCard',
];

/** Default visible registry columns for internal users BASIS (`select` filter). */
export const USER_REGISTRY_DEFAULT_SELECT: UserRegistryColumnKey[] = [...USER_REGISTRY_COLUMN_KEYS];

/** Registry `select` for dropdowns and widgets. */
export const USER_WIDGET_REGISTRY_SELECT = [
  'id',
  'profile',
  'job',
  'banned',
  'deleted',
  'roles',
] as const satisfies readonly (keyof UserFindInterface)[];

/** Internal users BASIS registry column selection - DTO signature */
export type UserRegistrySelectInterface = SelectFieldsInterface<UserFindInterface>;

/** Internal users BASIS registry column selection - DTO schema */
export const UserRegistrySelectDto = createSelectFieldsDto(
  SecurityDtoKeysEnum.USER_REGISTRY_SELECT_DTO,
  UserFindDto,
  {
    maxDepth: 2,
    default: [...USER_REGISTRY_DEFAULT_SELECT] as (keyof UserFindInterface)[],
    extraKeyPatterns: [/^activitiesCount$/],
  },
);
